import React from 'react';
import { StructureLevelTree } from 'components/StructureLevel';

const PageStructureLevelTree = () => (
  <StructureLevelTree />
);

export default PageStructureLevelTree;
